import { isObject, isString } from 'util';

import { UraniaCfg } from '@gosuite/urania-admin';

import * as UraniaAdminActions from '../actions/urania-admin';


export interface State {
	selectedCfg: UraniaCfg;
}

export const InitialState: State = {
	selectedCfg: null
};


export function reducer(state: State = InitialState, action: UraniaAdminActions.All): State {
	switch (action.type) {
		case UraniaAdminActions.SELECT_URANIA_CFG:
			return { ...state, selectedCfg: isObject(action.payload) && isString(action.payload.cfg) ? action.payload : null };

		default:
			return state;
	}
}


export const GetSelectedUraniaCfg = (s: State): UraniaCfg => s.selectedCfg;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/reducers/urania-admin.ts